import gql from "graphql-tag";
import AssetDiscussionCommentReplyFields from "./AssetDiscussionCommentReplyFields";

export default gql`
  fragment AssetDiscussionCommentRepliesPaginationFields on AssetDiscussionCommentRepliesPagination {
    totalCount
    nodes {
      ...AssetDiscussionCommentReplyFields
    }
    pageInfo {
      cursor
      hasNextPage
    }
  }

  ${AssetDiscussionCommentReplyFields}
`;
